export enum Language {
  EN = 'en-US',
  PL = 'pl-PL',
}

export const defaultLanguage = Language.PL;

export const localStorageLanguageKey = 'i18nextLng';
